export const RdstationTypes = {
  SET_FORM_INITIAL: 'SET_FORM_INITIAL',
}
